import * as FileConstants from 'folder-items/FileConstants';
import {UnaffiliatedSchemaTag} from 'folder-items/FileConstants';
import {ENTER, ESCAPE, TAB} from 'notebook/tables/TableShortcuts';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {ElementKeyboardEvent} from 'util/Types';

function tableMultiKeyDownHandler<
  T extends string | FileConstants.SchemaTag | UnaffiliatedSchemaTag | TypedValue | null,
>({
  event,
  value,
  onSetValue,
  onEscape,
  onTabKey,
}: {
  event: ElementKeyboardEvent;
  value: T;
  onSetValue: (value: T, enterKey?: boolean) => void;
  onEscape: (e: ElementKeyboardEvent) => void;
  onTabKey?: (e: ElementKeyboardEvent) => void;
}): void {
  if (ENTER.matches(event)) {
    event.preventDefault();
    onSetValue(value, true);
  } else if (ESCAPE.matches(event)) {
    event.preventDefault();
    onEscape(event);
  } else if (TAB.matches(event) && onTabKey !== undefined) {
    event.preventDefault();
    onSetValue(value, false);
    onTabKey(event);
  }
}

export default tableMultiKeyDownHandler;
